import { types } from './actions';

const initialState = {
  isCopyAnalyticsDrawerOpen: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.COPY_ANALYTICS_DRAWER_OPEN:
      return {
        ...state,
        isCopyAnalyticsDrawerOpen: true,
      };
    case types.COPY_ANALYTICS_DRAWER_CLOSE:
      return {
        ...state,
        isCopyAnalyticsDrawerOpen: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.common.drawers.copyAnalyticsDrawer;

export const getIsCopyAnalyticsDrawerOpen = (state) =>
  getScope(state).isCopyAnalyticsDrawerOpen;
